// extracted by mini-css-extract-plugin
export default {"pageWrap":"ae-z","fullWidth":"be-z","heading":"ce-z","fullBleed":"de-z","hidden":"ee-z"};